import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CFormSwitch,
  CFormText,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import Multiselect from 'multiselect-react-dropdown'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import moment from 'moment'
import { createMetaData, updateMetaData } from '../../../../Redux/Actions/metaDataAction'
import {
  activeArray,
  checkPermissions,
  isEmpty,
  masterAndChildIntersection,
} from 'src/views/utils/helper'
import { dispatchAlert } from 'src/Redux/Actions/authAction'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { GlobalContext } from 'src/views/context/GlobalState'
import SearchTable from 'src/components/searchTable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import { AppContext } from 'src/views/context/app'

const SubCategoryListing = ({ subCategories, categories }) => {
  const [showModal, setShowModal] = useState(false)
  const [editFlag, setEditFlag] = useState(false)

  const [mapSubcategory, setMapSubcategory] = useState([])
  const [selectedEditCategory, setSelectedEditCategory] = useState([])
  const [subCategoryName, setSubCategoryName] = useState('')
  const [editSubCategory, setEditSubCategory] = useState('')
  const [selectedCategory, setSelectedCategory] = useState([])
  const dispatch = useDispatch()
  const language = localStorage.getItem('language')

  const { accountObj } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const defaultLangCheck = language === accountObj?.default_language
  const isCreateAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.META_DATA.CREATE) &&
    defaultLangCheck

  const isUpdateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.META_DATA.UPDATE,
  )

  useEffect(() => {
    if (!isEmpty(subCategories)) {
      let tempSub = []
      subCategories.forEach((ele) => {
        let tempEle = ele
        tempEle[`categoryString`] = mapCategoryData(ele.categories)
        tempSub.push(tempEle)
      })
      setMapSubcategory(tempSub)
    }
  }, [subCategories])

  const [errorData, setErrorData] = useState({})

  const handleSelectCategory = (info, type) => {
    setErrorData({ ...errorData, selectedCategory: '' })
    if (type === 'add') {
      setSelectedCategory((selectedCategory) => [...selectedCategory, info._id])
    } else if (type === 'remove') {
      setSelectedCategory((selectedCategory) => selectedCategory.filter((cat) => cat !== info._id))
    }
    // setSelectedCategory(selectedCategory=>selectedCategory.filter((cat)=>type === 'add'?))
  }

  const handleStatus = async (info) => {
    if (!isUpdateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    let res = await dispatch(updateMetaData('system', info._id, { status: !info.status }))
    if (res?.success) {
      dispatch({ type: 'REFRESH_DATA' })
    }
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {
      subCategoryName: '',
      selectedCategory: '',
    }

    if (subCategoryName.trim().length === 0) {
      isFormValid = false
      temp.subCategoryName = 'Name cannot be Empty!'
    }
    if (isEmpty(selectedCategory)) {
      isFormValid = false
      temp.selectedCategory = 'Select Category!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSubmit = async () => {
    if (validateInfo()) {
      let data = {
        name: subCategoryName,
        type: 'sub_category',
        categories: selectedCategory,
      }
      let res = await dispatch(createMetaData('system', data))
      if (res?.success) {
        dispatch({ type: 'REFRESH_DATA' })
        emptyState()
        setShowModal(false)
      }
    }
  }
  const handleEditSubcategory = async () => {
    if (validateInfo()) {
      let data = {
        name: subCategoryName,
        categories: selectedCategory,
      }
      let res = await dispatch(updateMetaData('system', editSubCategory._id, data))
      if (res?.success) {
        dispatch({ type: 'REFRESH_DATA' })
        emptyState()
        setShowModal(false)
      } else {
        console.log('failed')
      }
    }
  }

  const handleEdit = (data) => {
    if (!isUpdateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    setEditFlag(true)
    setSubCategoryName(data.name)
    setEditSubCategory(data)

    let tempCategory = categories.filter((cat) => data.categories.includes(cat._id))
    const intersectionData = masterAndChildIntersection(categories, tempCategory)

    setSelectedCategory(intersectionData.map((obj) => obj._id))
    setSelectedEditCategory(intersectionData)
    setShowModal(true)
  }

  const emptyState = () => {
    setSubCategoryName('')
    setSelectedCategory([])
    setErrorData({})
    setEditFlag(false)
    setSelectedEditCategory([])
  }

  const mapCategoryData = (categoriesId) => {
    // eslint-disable-next-line array-callback-return
    const category_list = []

    categories.forEach((cat) => {
      if (categoriesId.includes(cat._id)) {
        category_list.push(cat.name)
      }
    })
    return category_list.filter((item) => item !== '').join(', ')
  }

  const tableConfig = [
    {
      header: 'Sub-Category Name',
      dataCell: (info) => info.name,
      width: 25,
    },
    {
      header: 'Mapped to Category',
      dataCell: (info) => info.categoryString,
      width: 35,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 15,
    },
    {
      header: 'Status',
      dataCell: (info) => (
        <CFormSwitch
          label={info.status ? 'Active' : 'Disabled'}
          checked={info.status}
          valid={info.status}
          value={info.status}
          onChange={() => handleStatus(info)}
          size="lg"
        />
      ),
      width: 15,
    },
    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => (
        <CIcon
          icon={cilPencil}
          style={{ cursor: 'pointer' }}
          size="lg"
          title="Edit"
          onClick={() => handleEdit(info)}
        />
      ),
      width: 5,
    },
  ]
  return (
    <div>
      <SearchTable
        type={`Sub-Category Metadata`}
        tableCardHeight={63}
        marginDisable={true}
        titleText={`Define the Content Sub-Categories within a Category.`}
        disableButton={false}
        buttonName={`Add Sub-Category`}
        buttonFunction={() => setShowModal(true)}
        searchTerm={`name`}
        tableContent={mapSubcategory}
        tableConfig={tableConfig}
        createPermission={isCreateAllowed}
        disabledButtonTitle={
          defaultLangCheck ? '' : 'Adding Sub-Category Available on Default Language'
        }
      />

      <CModal size="lg" visible={showModal} alignment="center">
        <CModalHeader className="px-5 py-4">
          <CModalTitle>{editFlag ? 'Edit ' : 'Add '}Sub-Category</CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <div className="mb-">
            <CFormLabel>Sub-Category Name*</CFormLabel>
            <CCol lg="12">
              <CFormInput
                type="text"
                value={subCategoryName}
                onChange={(e) => {
                  setSubCategoryName(e.target.value)
                  setErrorData({ ...errorData, subCategoryName: '' })
                }}
              />
              <div className="message-text error-message">
                <p>{errorData.subCategoryName}</p>
              </div>
            </CCol>
          </div>
          <div className="mt-4">
            <CFormLabel>Under the Category*</CFormLabel>
            <CRow>
              <CCol lg="12">
                <Multiselect
                  options={activeArray(categories)} // Options to display in the dropdown
                  selectedValues={editFlag ? selectedEditCategory : null}
                  color="red"
                  style={{
                    chips: {
                      background: 'blue',
                    },
                    searchBox: {
                      background: 'white',
                    },
                  }}
                  showCheckbox="true"
                  onSelect={(e, info) => handleSelectCategory(info, 'add')}
                  onRemove={(e, info) => handleSelectCategory(info, 'remove')}
                  displayValue="name" // Property name to display in the dropdown options
                />
                <div className="message-text error-message">
                  <p>{errorData.selectedCategory}</p>
                </div>
                <CFormText>
                  Mapping the Sub-Category to at-least one Category is mandatory.
                </CFormText>
              </CCol>
            </CRow>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton
            className="text-white"
            color="info"
            onClick={() => {
              emptyState()
              setShowModal(false)
            }}
          >
            Cancel
          </CButton>
          <CButton
            className="text-white"
            color="info"
            onClick={editFlag ? handleEditSubcategory : handleSubmit}
          >
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default SubCategoryListing
